<template>
	<div class="about-container">
		<img class="popularBgImg" src="../assets/Home/popularBgImg.png" />
		<div class="detailsBox">
			<div class="title">
				关于平台
			</div>
			<div class="msgContent" v-html="aboutContent">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'AboutPage',
		data() {
			return {
				aboutContent: '',
			}
		},
		mounted() {
			this.configData()
		},
		methods: {
			configData() {
				this.$api.post('/Other/config', {}).then(res => {
					if (res.code == 1) {
						res.data.forEach(item => {
							if (item.title == 'sys_content') {
								this.aboutContent = this.formatRichText(this.px2rem(item.value))
							}
						})
					}
				}).catch(err => {
					console.log(err);
				})
			},
			px2rem(html, base = 100) {
				if (!html) return html
				return html.replace(/(\d+(\.\d+)?)px/g, (_, px) => {
					return (px / base).toFixed(4) + 'rem'
				})
			},
			formatRichText(html) {
				let newContent = html.replace(/<img[^>]*>/gi, function(match) {
					match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
					match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
					match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
					match = match.replace(/style=""/gi, '').replace(/style=''/gi, '');
					return match;
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match) {
					match = match.replace(/width:[^;]+;/gi, 'width:100%;').replace(/width:[^;]+;/gi,
						'width:100%;');
					return match;
				});
				newContent = newContent.replace(/<img/gi,
					'<img style="width:100%;height:auto;display:block;margin:0px 0;"');

				return newContent;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.about-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #080808;
		min-height: 100vh;
		position: relative;

		.popularBgImg {
			position: absolute;
			width: 100%;
			bottom: 0;
			left: 0;
		}
	}

	.detailsBox {
		margin: .24rem auto .8rem;
		padding: .4rem .4rem;
		width: 12rem;
		border-radius: .08rem;
		background: #1F2027;
		z-index: 1;

		.title {
			font-weight: 700;
			font-size: .32rem;
			color: rgba(255, 255, 255, .8);
		}

		.msgContent {
			margin-top: .12rem;
			font-weight: 400;
			font-size: .16rem;
			color: #252525;
		}
	}
</style>
<style>
	.msgContent p {
		color: rgba(255, 255, 255, .8) !important;
	}
</style>